export const ugandaTours = [
  {
    id: "murchison-falls-3-day",
    title: "3-Day Murchison Falls Adventure Safari",
    duration: "3 Days / 2 Nights",
    description: "Experience the magnificent Murchison Falls National Park, home to diverse wildlife and the world's most powerful waterfall.",
    image: "/murchison-falls.jpg",
    href: "/tours/uganda/murchison-falls-3-day",
    price: "$850"
  },
  {
    id: "queen-elizabeth-3-day",
    title: "3-Day Queen Elizabeth National Park Safari",
    duration: "3 Days / 2 Nights",
    description: "Join us on an unforgettable journey to Queen Elizabeth National Park, where the savannah plains meet the majestic Mountain Rwenzori ranges.",
    image: "/leopard.png",
    href: "/tours/uganda/queen-elizabeth-3-day",
    price: "$900"
  },
  {
    id: "bwindi-gorilla-5-day",
    title: "5-Day Bwindi Gorilla Safari",
    duration: "5 Days / 4 Nights",
    description: "Set out on a vibrant Gorilla Trekking Adventure in Bwindi Impenetrable National Park with nature walks and cultural visits.",
  image: "/gorilla.webp",
    href: "/tours/uganda/bwindi-gorilla-5-day",
    price: "$2,500"
  },
  {
    id: "kidepo-valley-5-day",
    title: "5-Day Kidepo Valley Safari",
    duration: "5 Days / 4 Nights",
    description: "Explore the unspoiled wilderness of Kidepo Valley National Park, one of Africa's most breathtaking wildernesses.",
    image: "/5O5A0035.png",
    href: "/tours/uganda/kidepo-valley-5-day",
    price: "$1,800"
  },
  {
    id: "wildlife-5-day",
    title: "5-Day Uganda Wildlife Safari",
    duration: "5 Days / 4 Nights",
    description: "Discover Lake Mburo and Queen Elizabeth National Parks on this thrilling wildlife adventure.",
    image: "/Uganda-Wildlife-Safari.png",
    href: "/tours/uganda/wildlife-5-day",
    price: "$1,600"
  },
  {
    id: "adventure-8-day",
    title: "8-Day Adventure Safari",
    duration: "8 Days / 7 Nights",
    description: "An extensive tour covering Uganda's most spectacular wildlife destinations including gorilla trekking.",
    image: "/gorillabwindi.jpg",
    href: "/tours/uganda/adventure-8-day",
    price: "$3,200"
  },
  {
    id: "primates-wildlife-8-day",
    title: "8-Day Primates and Wildlife Safari",
    duration: "8 Days / 7 Nights",
    description: "Track chimpanzees in Kibale Forest and gorillas in Bwindi, plus explore Queen Elizabeth National Park.",
    image: "/gorillatrekking.png",
    href: "/tours/uganda/primates-wildlife-8-day",
    price: "$3,500"
  },
  {
    id: "experience-nature-19-day",
    title: "19-Day Uganda Experience Nature",
    duration: "19 Days / 18 Nights",
    description: "A comprehensive journey through Uganda's stunning landscapes and incredible wildlife.",
    image: "/kabale.jpg",
    href: "/tours/uganda/experience-nature-19-day",
    price: "$6,800"
  },
  {
    id: "cultural-wildlife-21-day",
    title: "21-Day Uganda Cultural and Wildlife Safari",
    duration: "21 Days / 20 Nights",
    description: "A journey through Uganda's stunning landscapes, incredible wildlife, and rich cultural heritage.",
    image: "/leopard.png",
    href: "/tours/uganda/cultural-wildlife-21-day",
    price: "$7,500"
  }
];

export const rwandaTours = [
  {
    id: "gorilla-2-day",
    title: "2 Days Rwanda Gorilla Safari",
    duration: "2 Days / 1 Night",
    description: "Track mountain gorillas in Volcanoes National Park on this concise Rwanda safari.",
  image: "/gorilla.webp",
    href: "/tours/rwanda/gorilla-2-day",
    price: "$1,800"
  },
  {
    id: "akagera-4-day",
    title: "4 Days Akagera National Park Safari",
    duration: "4 Days / 3 Nights",
    description: "Experience Rwanda's premier savanna park with its diverse wildlife and scenic landscapes.",
    image: "/akageralionrwanda.jpeg",
    href: "/tours/rwanda/akagera-4-day",
    price: "$2,200"
  },
  {
    id: "primates-5-day",
    title: "5 Days Rwanda Primates Safari",
    duration: "5 Days / 4 Nights",
    description: "Explore Rwanda's incredible primate species in Nyungwe Forest and Volcanoes National Park.",
    image: "/nyunguwemonkey.jpeg",
    href: "/tours/rwanda/primates-5-day",
    price: "$2,800"
  },
  {
    id: "volcanoes-7-day",
    title: "7 Days Volcanoes Adventure",
    duration: "7 Days / 6 Nights",
    description: "Discover the beauty of Rwanda's volcanic landscapes and mountain gorillas.",
  image: "/gorilla.webp",
    href: "/tours/rwanda/volcanoes-7-day",
    price: "$3,500"
  },
  {
    id: "safari-10-day",
    title: "10 Days Rwanda Safari",
    duration: "10 Days / 9 Nights",
    description: "Experience the complete Rwanda adventure with gorilla trekking, game drives, and cultural experiences.",
  image: "/gorilla.webp",
    href: "/tours/rwanda/safari-10-day",
    price: "$4,500"
  }
];

export const kenyaTours = [
  {
    id: "masai-mara-road-3-day",
    title: "3 Days Masai Mara Road Safari",
    duration: "3 Days / 2 Nights",
    description: "Experience a thrilling road safari to the world-famous Masai Mara National Reserve.",
    image: "/masaimaragreatmigration.png",
    href: "/tours/kenya/masai-mara-road-3-day",
    price: "$950"
  },
  {
    id: "masai-mara-road-4-day",
    title: "4 Days Masai Mara Road Safari",
    duration: "4 Days / 3 Nights",
    description: "Extended road safari to experience more of the magnificent wildlife of the Masai Mara.",
    image: "/masaimaragreatmigration.png",
    href: "/tours/kenya/masai-mara-road-4-day",
    price: "$1,200"
  },
  {
    id: "maasai-mara-3-day",
    title: "3 Days Maasai Mara Safari",
    duration: "3 Days / 2 Nights",
    description: "A classic safari experience in the world-famous Maasai Mara National Reserve.",
    image: "/masaimaragreatmigration.png",
    href: "/tours/kenya/maasai-mara-3-day",
    price: "$950"
  },
  {
    id: "nakuru-maasai-mara-5-day",
    title: "5 Days Lake Nakuru & Maasai Mara",
    duration: "5 Days / 4 Nights",
    description: "Discover the flamingos of Lake Nakuru and the abundant wildlife of Maasai Mara.",
    image: "/lakenakuruflamingos.jpg",
    href: "/tours/kenya/nakuru-maasai-mara-5-day",
    price: "$1,700"
  },
  {
    id: "family-7-day",
    title: "7 Days Family Safari",
    duration: "7 Days / 6 Nights",
    description: "A family-friendly safari adventure through Kenya's most accessible wildlife parks.",
    image: "/cubslakenakuru.jpg",
    href: "/tours/kenya/family-7-day",
    price: "$2,500"
  },
  {
    id: "magical-9-day",
    title: "9 Days Magical Kenya Safari",
    duration: "9 Days / 8 Nights",
    description: "Experience the magic of Kenya from the savannah plains to mountain forests.",
    image: "/kenyssafarizebra.jpg",
    href: "/tours/kenya/magical-9-day",
    price: "$3,200"
  }
];

export const tanzaniaTours = [
  {
    id: "wildlife-8-day",
    title: "8 Days Wildlife Tanzania Safari",
    duration: "8 Days / 7 Nights",
    description: "Explore the breathtaking landscapes and incredible wildlife of Tanzania's national parks.",
    image: "/serengetiwildbeastmigration.png",
    href: "/tours/tanzania/wildlife-8-day",
    price: "$3,200"
  },
  {
    id: "safari-6-day",
    title: "6 Days Tanzania Safari",
    duration: "6 Days / 5 Nights",
    description: "A comprehensive tour of Tanzania's most iconic wildlife destinations.",
    image: "/serengetiwildbeastmigration.png",
    href: "/tours/tanzania/safari-6-day",
    price: "$2,800"
  },
  {
    id: "safari-2-day",
    title: "2 Days Tanzania Safari",
    duration: "2 Days / 1 Night",
    description: "A quick weekend getaway to experience Tanzania's abundant wildlife.",
    image: "/serengetiwildbeastmigration.png",
    href: "/tours/tanzania/safari-2-day",
    price: "$900"
  }
];